<script>
    import store from '../../../Stores/motivo-store';
    import storeMotivos from '../../../Stores/motivos-store';
    import axios from '../../../axios-control';

    import {validaMotivo} from '../../../Modelos/Motivo';

    import Caja from "../../UI/Caja.svelte";
    import Subtitulo from "../../UI/Subtitulo.svelte";
    import Icono from "../Icono.svelte";
    import CampoDeTexto from "../../UI/CampoDeTexto.svelte";
    import CampoDeSeleccion from "../../UI/CampoDeSeleccion.svelte";
    import CampoDeCheckbox from "../../UI/CampoDeCheckbox.svelte";
    import Boton from "../../UI/Boton.svelte";
    import CampoDeIcono from "../../UI/CampoDeIcono.svelte";

    import {createEventDispatcher} from 'svelte';

    const dispatch = createEventDispatcher();

    let motivo, error, errores;
    $: motivo = $store.motivo;
    $: errores = validaMotivo(motivo);
    $: error = $store.error;

    let estadoInicial;
    $: estadoInicial = estadoInicial || $store.motivo;

    let sucio = false;
    $: sucio = JSON.stringify(estadoInicial) !== JSON.stringify($store.motivo);

    const tiposDeMotivo = ['Actividad', 'Ausencia'];

    const actualizaCampo = (campo, valor) => store.actualizaCampo(campo, valor);

    const enviaFormulario = e => {
        e.preventDefault();
        estadoInicial = null;
        store.guarda().then(() => storeMotivos.cargar()).then(() => dispatch('enviado'));
    };

    let iconos;
    axios.get('/motivos/imagenes').then(x => iconos = x.data);
</script>

<style>
    @media (min-width: 1024px) {
        .fila {
            display: grid;
            grid-template-columns: 1fr 1fr;
            grid-gap: var(--padding-global);
        }

        .fila-3 {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            grid-gap: var(--padding-global);
        }

        .fila-4 {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            grid-gap: var(--padding-global);
        }
    }
</style>

<Caja>
    <div slot="titulo">
        <Subtitulo>
            <Icono {motivo}/>

            {motivo.nombre}
        </Subtitulo>
    </div>

    <form on:submit={enviaFormulario}>
        <div class="fila-4">
            <CampoDeTexto id="nombre" label="Nombre" value={motivo.nombre}
                          icono="scatter_plot" valido={!errores.nombre}
                          mensajeDeError={errores.nombre} disabled={motivo.protegido}
                          on:input={e => actualizaCampo('nombre', e.target.value)}/>

            <CampoDeSeleccion id="tipo" label="Tipo" value={motivo.tipo}
                              valido={!errores.tipo} mensajeDeError={errores.tipo}
                              opciones={tiposDeMotivo} icono="category"
                              disabled={motivo.protegido || motivo.id}
                              on:input={e => actualizaCampo('tipo', e.target.value)}/>

            <CampoDeTexto id="codigo" label="Código telefónico" value={motivo.codigo}
                          icono="dialpad" valido={!errores.codigo}
                          mensajeDeError={errores.codigo}
                          on:input={e => actualizaCampo('codigo', e.target.value)}/>

            <CampoDeCheckbox id="automatico" label="Automático" value={motivo.automatico}
                             disabled={motivo.protegido}
                             on:change={e => actualizaCampo('automatico', e.detail)}/>
        </div>

        <div>
            <CampoDeIcono id="icono" label="Icono" value={motivo.icono}
                          valido={!errores.icono} mensajeDeError={errores.tipo}
                          {iconos} icono="image" disabled={motivo.protegido}
                          on:input={e => actualizaCampo('icono', e.detail)}/>
        </div>
    </form>

    <div slot="pie">
        <Boton on:click={enviaFormulario} type="submit"
               disabled={!sucio || Object.keys(errores).length}>
            Guardar
        </Boton>
    </div>
</Caja>